import { TagsPageHeader } from './TagsPageHeader.main';

export { TagsPageHeader };
